import Constant from '../lib/constant';
import axiosClient from './axiosClient';

const url = Constant.apiUrl + '/contact';
const contactApi = {
	get: (params) => axiosClient.get(url + '/admin', { params }),
	getById: (id) => axiosClient.get(url + `/admin/${id}`),
	update: (id, payload) => axiosClient.put(url + `/admin/${id}`, payload),
	delete: (id) => axiosClient.delete(url + `/admin/${id}`),
};

export default contactApi;
